import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { JudgePhaseProjectType, ProjectType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { GET_PROJECT_IN_JUDGE_PHASE_PROJECTS_BY_ID_JUDGE, JUDGE_PHASE_PROJECTS } from "../../utils/constants";

export const createJudgePhaseProject = async (data: JudgePhaseProjectType) => await post<JudgePhaseProjectType, string>(JUDGE_PHASE_PROJECTS, data);
export const updateJudgePhaseProject = async (data: JudgePhaseProjectType) => await put<JudgePhaseProjectType, string>(JUDGE_PHASE_PROJECTS, data);

export const getJudgePhaseProjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdProject ? { IdProject: data.IdProject  } : {}),

    });
    const url = `${JUDGE_PHASE_PROJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<JudgePhaseProjectType>>(url);
};
export const getProjectsAssignedByIdJudge = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdJudge ? { IdJudge: data.IdJudge  } : {}),
    });
    const url = `${GET_PROJECT_IN_JUDGE_PHASE_PROJECTS_BY_ID_JUDGE}?${queryParams.toString()}`;
    return await get<PagedResultsType<ProjectType>>(url);
};

